import React from "react"
import {Trans, useTranslation} from "react-i18next"
import {ChevronLeftIcon} from "@heroicons/react/20/solid"

import {HeroLayout} from "../../../../components/HeroLayout.tsx"
import {LayoutCard} from "../../../../components/LayoutCard.tsx"
import {Link} from "../../../../components/Link.tsx"
import {useDocumentTitle} from "../../../../utils/hooks.tsx"
import {commonTransComponents} from "../../../../utils/i18n.tsx"

export const RegistrationUnavailablePage: React.FC = () => {
  const {t} = useTranslation()

  useDocumentTitle(t("Signup_DocumentTitle"))

  return (
    <HeroLayout
      leftAction={
        <Link to={"/sign-up"} variant={"neutral"} flipUnderline className={"inline-flex items-baseline gap-1"}>
          <ChevronLeftIcon className={"size-5 self-center"} />
          <span>{t("Signup_BackLink")}</span>
        </Link>
      }
    >
      <LayoutCard title={t("Signup_Company_Managing_Unavailable_Title")}>
        <p>
          <Trans
            i18nKey={"Signup_Company_Managing_Unavailable_Text"}
            components={{
              ...commonTransComponents,
              supportLink: <Link to={"mailto:support@closerocket.com"} target={"_blank"} />,
            }}
          />
        </p>
      </LayoutCard>
    </HeroLayout>
  )
}
